import { Injectable } from "@angular/core";
import { BackendService } from '@toro/common/shared/services/new-http/backend.service';
import { Observable } from "rxjs";
import { ISTVMDigital, ISTVMDigitalPortability } from "../../interfaces/stvm-digital.interface";

@Injectable({
    providedIn: 'root',
})
export class STVMDigitalService extends BackendService {

    public getPortabilities(): Observable<Array<ISTVMDigital>> {
        return this.api.get<Array<ISTVMDigital>>('/api/stvm/v1/portabilities');
    }

    public acceptPortability(portability: ISTVMDigitalPortability): Observable<any> {
        return this.api.post('/api/stvm/v1/portability/accept', portability);
    }
}